<template>
  <v-container>
    <v-dialog v-model="dialog_value.show" width="500px" @click:outside="$store.commit('close_edit_tag_dialog')">
      <v-card>
        <validation-observer v-slot="{ invalid }">
          <v-card-title>
            اصلاح متن
          </v-card-title>
          <v-card-text>

            <validation-provider
                v-slot="{ errors }"
                rules="required"
            >
              <v-text-field
                  label="نام فیلد"
                  v-model="dialog_value.label"
                  :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" flat @click="$store.commit('close_edit_tag_dialog')">
              لغو
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="invalid" flat @click="edit">
              ویرایش
            </v-btn>
          </v-card-actions>
        </validation-observer>

      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {mapState} from "vuex";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  extend,
} from "vee-validate";
import {required} from "vee-validate/dist/rules";


setInteractionMode("aggressive");

extend("required", {
  ...required,
  message: "پر کردن این قسمت اجباریست",
});

export default {
  name: "EditTagDialog",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    ...mapState({
      dialog_value: state => state.Admin.settings.edit_tag_dialog
    }),
  },
  methods: {
    edit() {
      this.$store.dispatch('update_field', {label: this.dialog_value.label, field_id: this.dialog_value.field_id})
    }
  }
}
</script>

<style scoped>

</style>
